export default {
  SPIN: 'ZAKRĘĆ',
  'You are not eligible for free spins':
    'Tylko konta steam z grą CSGO a nie VAC mogą dostać darmowe monety. Zaloguj się ponownie na stronę, aby odświeżyć.',
  'It must be 24 hours since last roll': 'Musi to być 24 godziny przed przed ostatnim rzutem.',
};
